import"react";import{createPortal as r}from"react-dom";var o=function(o){return r(o.children,document.body)};export{o as default};
//# sourceMappingURL=BodyPortal.js.map
